import React, { useEffect, useRef } from 'react';
import styles from './style.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers,
    faEye,
    faClipboardList,
    faMapMarkerAlt,
    faCalendarCheck,
    faClock,
    faUserGraduate
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import constant from '../../constant';

const RegisteredCampusDriveList = ({
    drives,
    fetchDrives,
    hasMore,
    isLoading,
    page
}) => {

    const bottomRef = useRef(null);
    const observerRef = useRef(null);
    const history = useHistory();

    useEffect(() => {
        if (!hasMore) return;

        observerRef.current = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !isLoading) {
                    fetchDrives(page + 1);
                }
            },
            {
                root: null,
                rootMargin: '120px',
                threshold: 0.1
            }
        );

        if (bottomRef.current) {
            observerRef.current.observe(bottomRef.current);
        }

        return () => {
            if (observerRef.current && bottomRef.current) {
                observerRef.current.unobserve(bottomRef.current);
            }
        };
    }, [hasMore, isLoading]);

    return (


        <div className='col-md-12 my-3'>
            <div className={`${styles['job-lists']}`}>
                <div className='row'>
                    <div className='col-md-12'>
                        <h3 className={`${styles['intern-heading']}`}>Registered Campus Drive</h3>
                        <p>View and track all campus drives you’ve registered for.</p>

                        {drives.map((item) => (
                            <div className={`${styles['cp-banner-box']}`}>
                                <h4>{item.DRIVE_NAME}</h4>
                                <p className='mb-0'>{item.DRIVE_DESCRIPTION}</p>
                                <div className='d-flex align-items-center'>
                                    <div className={`${styles['fs-16']}`}>
                                        <FontAwesomeIcon className={styles['loc-icon']} icon={faMapMarkerAlt} />
                                       &nbsp; {item.COLLEGE_NAME}, {item.COLLEGE_CITY}
                                    </div>

                                    <div className={`${styles['fs-16']} mx-3`}>
                                        <FontAwesomeIcon className={styles['cal-icon']} icon={faCalendarCheck} />
                                       &nbsp; {moment(item.DRIVE_DATE).format('DD MMM YYYY')}
                                    </div>

                                    <div className={styles['fs-16']}>
                                        <FontAwesomeIcon className={styles['time-icon']} icon={faClock} />
                                       &nbsp; {item.DRIVE_START_TIME} - {item.DRIVE_END_TIME}
                                    </div>

                                    &nbsp; | &nbsp;

                                    <div className={styles['fs-16']}>
                                        <FontAwesomeIcon className={styles['time-icon']} icon={faUserGraduate} />
                                       &nbsp; Registered Students : {item.REGISTERED_STUDENTS}
                                    </div>

                                    &nbsp; | &nbsp;

                                    {<div className={styles['fs-16']}>
                                        <FontAwesomeIcon className={styles['time-icon']} icon={faUserGraduate} />
                                       &nbsp; Pending Attendance : {item.PENDING_STUDENTS}
                                    </div>}
                                </div>

                                <div className='mt-3'>
                                    <button onClick={() =>
                                        history.push(
                                            constant.component.campusDriveStudentPanel.url.replace(':id', item.REGISTRATION_ID)
                                        )
                                    } className={`${styles['reg-btn']}`}>Start Drive </button>
                                </div>
                            </div>

                        ))}
                        {hasMore && <div ref={bottomRef} style={{ height: 50, background: "transparent" }} />}
                        {!hasMore && drives.length === 0 && (
                            <div className={`${styles['no-campus-box']} mt-3`}>
                                <h4>No Registered Campus Drives Found</h4>
                            </div>
                        )}



                        {/* <div className={`${styles['all-lists']}`}>
                            {drives.map((item) => (
                                <div className="card mb-3" key={item.DRIVE_ID}>
                                    <div className="card-body">

                                        <div className="d-flex justify-content-between align-items-center">
                                            <h5 className={styles['card-titletext']}>
                                                {item.DRIVE_NAME}
                                                <span className={`${styles['badge-list']} ${styles[item.DRIVE_STATUS.toLowerCase()]}`}>
                                                    {item.DRIVE_STATUS}
                                                </span>
                                            </h5>

                                            <button
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() =>
                                                    history.push(
                                                        constant.component.campusDriveStudentPanel.url.replace(':id', item.REGISTRATION_ID)
                                                    )
                                                }
                                            >
                                                <FontAwesomeIcon icon={faEye} /> Student Panel
                                            </button>
                                        </div>

                                        <p className="text-muted mb-1">
                                            🎓 {item.COLLEGE_NAME}, {item.COLLEGE_CITY}
                                        </p>

                                        <p className="text-muted mb-2">
                                            📅 {moment(item.DRIVE_DATE).format('DD MMM YYYY')} | ⏰
                                            {item.DRIVE_START_TIME} - {item.DRIVE_END_TIME}
                                        </p>

                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <FontAwesomeIcon icon={faUsers} />&nbsp;
                                                {item.STUDENT_COUNT || 0} Students Met
                                            </div>

                                            <div>
                                                <FontAwesomeIcon icon={faClipboardList} />&nbsp;
                                                {item.INTERVIEW_COUNT || 0} Interviews
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))}
                            
                        </div> */}
                    </div>
                </div>
            </div>
        </div>

    );
};

export default RegisteredCampusDriveList;
